import React from 'react';
import { observer } from 'mobx-react';
import { useRouter } from 'next/router';

import { IStorageSnapshotIn, Provider, useStorage } from '../models/Storage';
import setVhVw from '../helpers/setVhVw';
import Header from '../components/Header/Header';
import { Main } from '../screens/Main/Main';

import classes from './index.module.scss';

type Props = {
    initialState: IStorageSnapshotIn;
};

export default observer<React.FC<Props>>(function Home() {
    const router = useRouter();

    const { target } = router.query;

    const storage = useStorage();

    React.useEffect(() => {
        const listener = () => {
            setVhVw(window);
        };
        listener();
        window.addEventListener('resize', () => {
            listener();
        });
        return window.removeEventListener('resize', () => {
            listener();
        });
    });

    return (
        <Provider value={storage}>
            <main className={classes.main}>
                <Header />
                <Main />
            </main>
        </Provider>
    );
});
